import Class from '@/Class';
import type GroupFactory from '@/Factories/GroupFactory';
import type ControlFactoryTuple from '@/Factories/ControlFactoryTuple';

export default class GroupFactoryTuple extends Class {

    public factory: GroupFactory;
    public control: JQuery<HTMLElement>;

    constructor(factory: GroupFactory, $control: JQuery) {
        super();

        this.factory = factory;
        this.control = $control;
        this.undisposeProperties.push('factory');
        this.isDisposable = true;
    }

    public getCreatedControlTuples(recursive: boolean = false): Array<ControlFactoryTuple> {
        let tuples: Array<ControlFactoryTuple> = [];

        for (let i = 0; i < this.factory.detailViewGroup.items.length; i++) {
            let name = this.factory.detailViewGroup.items[i].name;
            let tuple = this.factory.context.getCreatedTuple(name) as ControlFactoryTuple;

            if (tuple != null) {
                tuples.push(tuple);
            }
        }

        if (recursive) {
            for (let i = 0; i < this.factory.detailViewGroup.detailViewGroups.length; i++) {
                const group = this.factory.detailViewGroup.detailViewGroups[i];
                const groupFactoryTuple = this.factory.context.getCreatedTuple(group.name) as GroupFactoryTuple;
                if (groupFactoryTuple) {
                    const subArray = groupFactoryTuple.getCreatedControlTuples(recursive);
                    tuples = tuples.concat(subArray);
                }
            }
        }

        return tuples;
    }
}